import { default as RCTable } from 'rc-table';
import styled, { keyframes } from 'styled-components';

import { theme } from '@frontend/components/src/theme/theme';

const rowExpandAnim = keyframes`
    0% { max-height: 0rem; padding: 0rem 0rem }
    100% { max-height: 1000rem; padding: 0rem 0rem }
`;

/**
 * STYLED RC TABLE: Core styling for the table applied to the react-components table from rc-table.
 *
 * @deprecated use TableV2 and its subcomponents from '@frontend/components' instead.
 */
const StyledRCTable = styled(RCTable)`
  box-sizing: border-box;
  color: ${(props) => props.theme.colors.feature.primary};
  font-family: ${(props) => props.theme.fonts.default};
  font-size: ${(props) => props.theme.fontSizes.md};
  font-weight: ${(props) => props.theme.fontWeights.default};
  line-height: ${(props) => props.theme.lineHeights.md};
  position: relative;
  border-radius: ${(props) =>
    props.styleOptions.outerBorder != null
      ? props.styleOptions.outerBorder == false
        ? 0
        : '0.5rem'
      : '0.5rem'};
  /* overflow: hidden; @TODO resolve if this is necessary in bug fixing*/

  .rc-table-title {
    border-bottom: 1px solid ${(props) => props.theme.colors.separator.divider};
  }

  .rc-table-body {
    margin-bottom: -1px;
  }

  .rc-table-container {
    ${(props) =>
      props.styleOptions.outerBorder != null
        ? props.styleOptions.outerBorder == false
          ? 0
          : `
            border-top-left-radius: ${
              props.title == null ? '0.5rem' : 'initial'
            };
            border-top-right-radius: ${
              props.title == null ? '0.5rem' : 'initial'
            };
            border-bottom-left-radius: ${
              props.footer == null ? '0.5rem' : 'initial'
            };
              border-bottom-right-radius: ${
                props.footer == null ? '0.5rem' : 'initial'
              };
            `
        : `
            border-top-left-radius: ${
              props.title == null ? '0.5rem' : 'initial'
            };
            border-top-right-radius: ${
              props.title == null ? '0.5rem' : 'initial'
            };
            border-bottom-left-radius: ${
              props.footer == null ? '0.5rem' : 'initial'
            };
            border-bottom-right-radius: ${
              props.footer == null ? '0.5rem' : 'initial'
            };
          `};
    position: relative;
    overflow: hidden;
  }

  table {
    border-spacing: 0px;
    border-collapse: separate;

    margin-bottom: ${(props) => (props.scroll.y == null ? '-1px' : 'unset')};

    /* Left side shadows for tables without fixed left columns */

    ::before {
      background: linear-gradient(
        -90deg,
        rgba(0, 0, 0, 0) 45%,
        rgba(0, 0, 0, 0.03) 70%,
        rgba(0, 0, 0, 0.15) 100%
      );
      bottom: -1px;
      /* content: ''; @TODO RESOLVE THIS --> REMOVED SO THAT FIXED LAYOUT TABLE WORKS IN SAFARI */
      left: 0;
      opacity: 0;
      pointer-events: none;
      position: absolute;
      top: 0;
      transition: opacity 0.3s;
      width: 20px;
      z-index: 10;
      height: 100%;

      /* Cut off shadows for bordered table without title block*/
      ${(props) =>
        props.styleOptions.outerBorder != null
          ? props.styleOptions.outerBorder == false
            ? null
            : `border-top-left-radius: ${
                props.title == null ? '0.5rem' : 'initial'
              };
                  `
          : `border-top-left-radius: ${
              props.title == null ? '0.5rem' : 'initial'
            };
                `}

      /* Cut off shadows for bordered table without footer*/
      ${(props) =>
        props.styleOptions.outerBorder != null
          ? props.styleOptions.outerBorder == false
            ? null
            : `border-bottom-left-radius: ${
                props.footer == null ? '0.5rem' : 'initial'
              };
                `
          : `border-bottom-left-radius: ${
              props.footer == null ? '0.5rem' : 'initial'
            };
            `}
    }

    /* Right side shadows for tables without fixed right columns */
    ::after {
      background: linear-gradient(
        90deg,
        rgba(0, 0, 0, 0) 45%,
        rgba(0, 0, 0, 0.03) 70%,
        rgba(0, 0, 0, 0.15) 100%
      );
      bottom: -1px;
      content: '';
      opacity: 0;
      pointer-events: none;
      position: absolute;
      right: 0;
      top: 0;
      transition: opacity 0.3s;
      width: 20px;
      z-index: 10;
      height: 100%;

      /* Cut off shadows for bordered table without title block*/
      ${(props) =>
        props.styleOptions.outerBorder != null
          ? props.styleOptions.outerBorder == false
            ? null
            : `border-top-right-radius: ${
                props.title == null ? '0.5rem' : 'initial'
              };
                  `
          : `border-top-right-radius: ${
              props.title == null ? '0.5rem' : 'initial'
            };
                `}

      /* Cut off shadows for bordered table without footer*/
      ${(props) =>
        props.styleOptions.outerBorder != null
          ? props.styleOptions.outerBorder == false
            ? null
            : `border-bottom-right-radius: ${
                props.footer == null ? '0.5rem' : 'initial'
              };
                `
          : `border-bottom-right-radius: ${
              props.footer == null ? '0.5rem' : 'initial'
            };
            `}
    }

    /* ----------------------------------------------------------------- */
    .sort-icon {
      color: ${(props) => props.theme.colors.feature.placeholder};
      flex-direction: column;
      justify-content: center;
      margin-left: 0.25rem;
      margin-right: 0.75rem;

      .caret-ascending,
      .caret-descending {
        display: none;
        position: absolute;
      }

      .caret-ascending {
        top: 22.5%;
      }

      .caret-descending {
        top: 57.5%;
      }
    }

    .filter-icon {
      color: ${(props) => props.theme.colors.feature.placeholder};
    }

    .filtered .filter-icon {
      color: ${(props) => props.theme.colors.interaction.main};
    }
    /* TURN THIS CODE BACK ON FOR FILTER ICON BLUE WHEN ONLY SORTED*/
    /* .sortable-ascending.sorted-ascending .filter-icon,
    .sortable-descending.sorted-descending .filter-icon {
      color: ${(props) => props.theme.colors.interaction.main};
    } */

    .sortable-ascending:not(.sortable-descending),
    .sortable-descending:not(.sortable-ascending) {
      .caret-ascending {
        top: 32.5%;
      }
      .caret-descending {
        top: 32.5%;
      }
    }

    .sortable-ascending .sort-icon .caret-descending {
      margin-top: -0.25rem;
    }
    .sortable-ascending .sort-icon .caret-ascending {
      display: unset;
    }
    .sortable-descending .sort-icon .caret-descending {
      display: unset;
    }

    .sortable-ascending.sorted-ascending .caret-ascending,
    .sortable-descending.sorted-descending .caret-descending {
      color: ${(props) => props.theme.colors.interaction.main};
    }

    /* ----------------------------------------------------------------- */

    .rc-table-cell {
      border-bottom: 1px solid
        ${(props) => props.theme.colors.separator.divider};
      /* Cell padding for every table cell unless set elsewhere in this file */
      /* @TODO Make these X paddings dependent on table size, also make the cells fixed height unless specified by the engineer*/
      padding: 0.5rem 0.75rem;
      /*@TODO Add height sizing back!  also add to header cells. */
      position: relative;
      transition: box-shadow 0.3s;

      /* These properties are tied to the auto layout table mode, shouldn't be there for non-auto-layout tables, I think.  @TODO */

      ${(props) =>
        props.tableLayout === 'auto' &&
        `
          white-space: nowrap;
          word-break: break-word;
          width: 1px;
      `}
    }

    /* Styling for cells with expand icons inside them */

    .rc-table-cell.rc-table-row-expand-icon-cell {
      text-align: center;
      white-space: normal !important;
      position: sticky;
      left: 0px;
      /* This ensures that the expand column is shrunk to fit the content.*/
      /* Note that in safari, auto layout table cells with width: 1% will still expand slightly, 
      but only for tables that are super wide -  stretching an entire 27" monitor for example. */
      /* Fixed layout cells are given an arbitrary width to visually  match the width 1% cells from auto layout tables.*/
      width: ${(props) => (props.tableLayout === 'fixed' ? '2.8125rem' : '1%')};
      padding: 0rem 0.5rem;
    }

    .rc-table-cell.selection-cell {
      width: ${(props) => (props.tableLayout === 'fixed' ? '2.8125rem' : '1%')};
    }

    /* We're not encouraging ellipsis, @TODO decide if we want to remove this*/

    .rc-table-cell.rc-table-cell-ellipsis {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .rc-table-cell.rc-table-cell-ellipsis.rc-table-cell-fix-left-first,
    .rc-table-cell.rc-table-cell-ellipsis.rc-table-cell-fix-left-last,
    .rc-table-cell.rc-table-cell-ellipsis.rc-table-cell-fix-right-first,
    .rc-table-cell.rc-table-cell-ellipsis.rc-table-cell-fix-right-last {
      overflow: visible;

      .rc-table-cell-content {
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
      }
    }

    td.rc-table-cell {
      background-color: ${(props) => props.theme.colors.page.surface};
    }
    td.rc-table-cell.sorted-ascending,
    td.rc-table-cell.sorted-descending,
    td.rc-table-cell.filtered,
    th.rc-table-cell.sorted-ascending,
    th.rc-table-cell.sorted-descending,
    th.rc-table-cell.filtered {
      filter: brightness(98%);
    }

    thead {
      th.rc-table-cell {
        background-color: ${(props) => props.theme.colors.page.plateLight};
        /* remove borders between header cells if specified @TODO Change this once we introduce variants*/
        border-right: 1px solid
          ${(props) =>
            props.styleOptions.headerColumnDividers != null
              ? props.styleOptions.headerColumnDividers == false
                ? props.theme.colors.page.plateLight
                : props.theme.colors.separator.divider
              : props.theme.colors.separator.divider};
        padding: 0rem;
        user-select: none;
        height: 2rem !important; /* @TODO Make this use size dependent styling */
        text-align: left;
        z-index: 2;
      }

      th.rc-table-cell-fix-left,
      th.rc-table-cell-fix-right {
        z-index: 3;
      }

      /* th.sortable {
        :hover {
          filter: brightness(97%);
          cursor: pointer;
        }
      } */

      .rc-table-cell-scrollbar::after {
        position: absolute;
        content: '';
        top: 0;
        bottom: 0;
        left: -1px;
        width: 1px;
        background: ${(props) => props.theme.colors.page.plateLight};
      }
    }

    /* Region mask during loading state @TODO This is sloppily implemented, decide on a better implementation!*/
    tbody::before {
      opacity: ${(props) => (props.loading ? 1 : 0)};
      pointer-events: ${(props) => (props.loading ? 'unset' : 'none')};
      align-items: center;
      background-color: rgba(255, 255, 255, 0.85);
      content: '';
      display: flex;
      flex-direction: row;
      height: calc(100% - 2rem);
      justify-content: center;
      position: absolute;
      width: 100%;
      z-index: 5;
    }

    tbody.rc-table-tbody {
      /* Styling for all body rows */

      tr.rc-table-row {
        /* Give body cells column dividers as necessary @TODO change this implementation once variants are introduced!*/

        td.rc-table-cell {
          transition: background-color 0.2s;
          border-right: 1px solid
            ${(props) =>
              props.styleOptions.bodyColumnDividers != null
                ? props.styleOptions.bodyColumnDividers == false
                  ? props.theme.colors.page.surface
                  : props.theme.colors.separator.divider
                : props.theme.colors.separator.divider};
        }
      }

      /* Styling for all body that can expand rows during hover state */

      tr.rc-table-row.canExpand:hover {
        cursor: ${(props) =>
          props.expandable?.expandRowByClick ? 'pointer' : 'unset'};

        td.rc-table-cell {
          ${(props) =>
            props.expandable?.expandRowByClick &&
            `background-color: ${props.theme.colors.interaction.surfaceHover}`}
        }
      }

      /* Styling for all body that can expand rows during active state */

      tr.rc-table-row.canExpand:active {
        td.rc-table-cell {
          ${(props) =>
            props.expandable?.expandRowByClick &&
            `background-color: ${props.theme.colors.interaction.surfaceActive}`}
        }
      }

      tr.rc-table-row.rowSelected {
        td.rc-table-cell {
          background-color: ${(props) =>
            props.theme.colors.interaction.surfaceHover};
        }
      }

      /* Styling for rows that can be clicked during hover state */

      tr.rc-table-row.canClick:hover {
        cursor: pointer;

        td.rc-table-cell {
          background-color: ${(props) =>
            props.theme.colors.interaction.surfaceHover};
        }
      }

      /* Styling for rows that can be clicked during active state */

      tr.rc-table-row.canClick:active {
        td.rc-table-cell {
          background-color: ${(props) =>
            props.theme.colors.interaction.surfaceActive};
        }
      }

      /* Placeholder cell styling @TODO check if this is sized correctly for variants*/

      tr.rc-table-placeholder {
        text-align: center;

        td.rc-table-cell {
          text-transform: capitalize;
          padding: 0 !important;

          div.rc-table-expanded-row-fixed {
            align-items: center;
            display: flex;
            flex-direction: column;
            min-height: 3rem; /* This height is for the placeholder container in fixed mode only @TODO check this -- doesn't seem to be fixed only. */
            justify-content: center;
            padding: 0rem !important;
          }
        }
      }

      tr.rc-table-expanded-row {
        position: relative;
        width: 100%;

        td.rc-table-cell {
          /* This fixes an issue where expanded content would mess up table layout auto*/
          /* Currently does not work in safari */
          /* display: block; <--- This makes the expand icon column stay the right size, but breaks expansion sticky on safari*/
          background-color: transparent;
          position: sticky;
          left: 0px;
          height: fit-content;
          /* This line ensures the expanded cell that holds the expanded content remains fitted to the size of the contained component.
         
                   /* A box shadow to indicate we've expanded to a lower depth
                   Lives on the top and bottom of the expanded region. */
          box-shadow: inset 0 0.5rem 0.5rem -0.5rem rgba(0, 0, 0, 0.25),
            inset 0 -0.5rem 0.5rem -0.5rem rgba(0, 0, 0, 0.25);
        }
      }

      /* Part of a fix where empty expanded rows were being shown for rows with children but no expanded content.*/

      tr.rc-table-expanded-row.hideExpandedContentRow {
        display: none;
      }
    }

    tfoot.rc-table-summary {
      td.rc-table-cell {
        background-color: ${(props) => props.theme.colors.page.plateLight};
        /* remove borders between summary cells if specified */
        border-right: 1px solid
          ${(props) =>
            props.styleOptions.summaryColumnDividers != null
              ? props.styleOptions.summaryColumnDividers == false
                ? props.theme.colors.page.plateLight
                : props.theme.colors.separator.divider
              : props.theme.colors.separator.divider};
      }
    }

    /* This is outside of tbody so it covers summary rows within footer*/
    tr {
      td.rc-table-cell:last-child {
        border-right: none !important;
      }
      th.rc-table-cell:last-child {
        border-right: none !important;
      }
    }

    .rc-table-cell-fix-left,
    .rc-table-cell-fix-right {
      z-index: 1;
    }

    .rc-table-cell-fix-left-first::after,
    .rc-table-cell-fix-left-last::after {
      background: linear-gradient(
        -90deg,
        rgba(0, 0, 0, 0) 45%,
        rgba(0, 0, 0, 0.03) 70%,
        rgba(0, 0, 0, 0.15) 100%
      );
      bottom: -1px;
      content: '';
      opacity: 0;
      position: absolute;
      pointer-events: none;
      right: -1px;
      top: 0;
      transform: translateX(100%);
      transition: opacity 0.3s;
      width: 20px;
    }

    .rc-table-cell-fix-right-first::after,
    .rc-table-cell-fix-right-last::after {
      background: linear-gradient(
        90deg,
        rgba(0, 0, 0, 0) 45%,
        rgba(0, 0, 0, 0.03) 70%,
        rgba(0, 0, 0, 0.15) 100%
      );
      bottom: -1px;
      content: '';
      left: -1px;
      opacity: 0;
      pointer-events: none;
      position: absolute;
      top: 0;
      transform: translateX(-93.5%);
      transition: opacity 0.3s;
      width: 20px;
    }
  }

  .rc-table-footer {
    border-top: 1px solid ${(props) => props.theme.colors.separator.divider};
    position: relative;
  }

  &.rc-table-scroll-horizontal {
    .rc-table-expanded-row .rc-table-cell {
      padding: 0rem !important;
    }
    .rc-table-placeholder .rc-table-expanded-row-fixed {
      padding: 0rem !important;
    }
  }

  .rc-table-expanded-row-fixed {
    animation-name: ${rowExpandAnim};
    animation-duration: 0.25s;
    /* padding: 0.5rem 0.75rem; */
    height: auto;
    cursor: initial;
  }

  .rc-table-cell.summary-empty {
    border-right-color: ${(props) =>
      props.theme.colors.page.plateLight} !important;
  }

  .rc-table-cell.summary-empty-before-full {
    border-right-color: ${(props) =>
      props.styleOptions.summaryColumnDividers != null
        ? props.styleOptions.summaryColumnDividers == false
          ? props.theme.colors.page.plateLight
          : props.theme.colors.separator.divider
        : props.theme.colors.separator.divider} !important;
  }

  &.rc-table-ping-right.rc-table-scroll-horizontal {
    .rc-table-cell-fix-right-first::after {
      border-right: 1px solid ${(props) => props.theme.colors.separator.divider};
    }

    .rc-table-cell-fix-right-first::after,
    .rc-table-cell-fix-right-last::after {
      opacity: 1; /* using opacity to bring in background: linear-gradient for shadow with a transition */
    }
  }

  /* Ensure tables without fixed right columns have shadows that appear when not scrolled all the way right */
  &.rc-table-ping-right.rc-table-scroll-horizontal:not(
      .rc-table-has-fix-right
    ) {
    table::after {
      opacity: 1;
    }
  }

  /* Ensure tables without fixed left columns have shadows that appear when not scrolled all the way left */
  &.rc-table-ping-left.rc-table-scroll-horizontal:not(.rc-table-has-fix-left) {
    table::before {
      opacity: 1;
    }
  }

  &.rc-table-ping-left.rc-table-scroll-horizontal {
    .rc-table-cell-fix-left-last {
      border-right-color: ${(props) =>
        props.theme.colors.separator.divider} !important;
    }

    .rc-table-cell-fix-left-first::after,
    .rc-table-cell-fix-left-last::after {
      /* REMOVED THIS BOX SHADOW because inset box shadows don't work in safari */
      /* box-shadow: inset 10px 0px 8px -8px rgba(0, 0, 0, 0.2); */
      opacity: 1; /* using opacity instead to bring in background: linear-gradient with a transition */
    }

    .rc-table-cell-fix-left-last.summary-empty {
      border-right-color: ${(props) => props.theme.colors.separator.divider};
    }
  }
`;

StyledRCTable.defaultProps = { theme };
export default StyledRCTable;
